<template>
  <div
    class="html_localResult"
    ref="html_localResult"
    v-if="datas.objectInfo && datas.objectInfo.length == 1"
  >
    <div class="main">
      <div class="left-box">
        <AbPlayerImg
          v-for="item in datas.objectInfo"
          :key="item.playerId"
          :playerImg="item.playerInfos[0].profilePicture"
          :playerNum="item.playerInfos[0].shirtNumber * 1"
          :playerName="item.playerInfos[0].playerName"
          :countryImg="item.teamLogo"
          :countryName="item.teamName"
        ></AbPlayerImg>
      </div>
      <div class="right-box">
        <span class="itemTextString">
          <span
            v-text="_valFormatHandler(`${statisticsModels[0].name}：`)"
          ></span>
          <NumberScrolling
            :tarVal="tableData[statisticsModels[0].statisticalEn]"
            :unit="''"
          ></NumberScrolling>
        </span>
        <span
          class="rowItem"
          v-for="item in statisticsModels[1]"
          :key="item.statisticalEn"
        >
          <span class="rowItem_bg"></span>
          <span
            class="rowItem_title"
            v-text="_valFormatHandler(item.name)"
          ></span>
          <span class="rowItem_val">
            <NumberScrolling
              :tarVal="tableData[item.statisticalEn]"
              :unit="item.suffix"
            ></NumberScrolling>
          </span>
        </span>
      </div>
    </div>
    <!-- <div class="bottom_tip">
          *2014年开始，FIBA男篮世锦赛，已改名为FIBA男篮世界杯
        </div> -->
  </div>
</template>

<script>
// 本场成绩
import AbPlayerImg from '../components/PlayerImg'
import NumberScrolling from '../components/NumberScrolling'
// import htmlDomToImage_base64_data_mixin from '@mixins/htmlDomToImage_base64_data'
export default {
  name: 'html_localResult',
  // mixins: [htmlDomToImage_base64_data_mixin],
  components: {
    AbPlayerImg,
    NumberScrolling,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
  },
  data() {
    return {}
  },
  created() {
    // 模拟数据
    console.debug(this.datas)
  },
  updated() {
    console.debug(`更新： ${this.datas}`)
  },
  computed: {
    tableData() {
      return this.datas.data.dataList && this.datas.data.dataList.length > 0
        ? this.datas.data.dataList[0]
        : {}
    },
    statisticsModels() {
      let fristObj = null
      let otherArr = []
      if (
        this.datas.statisticsModels &&
        this.datas.statisticsModels.length > 0
      ) {
        this.datas.statisticsModels.forEach((key, index) => {
          if (index === 0) {
            fristObj = key
          } else {
            otherArr.push(key)
          }
        })
      }
      return [fristObj, otherArr]
    },
  },
  methods: {
    _valFormatHandler(val, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (val && ceil) {
          data = `${val}${ceil ? ceil : ''}`
        } else {
        }
        data = val
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.html_localResult {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  .main {
    width: 80%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: var(--mixtmt_greyColor_main);

    .left-box {
      font-size: 0.972vw;
    }
    .right-box {
      margin-left: 2.083vw;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      .itemTextString {
        width: 20.83vw;
        text-align: left;
        font-size: 1.25vw;
        font-weight: bold;
        color: var(--mixtmt_greyColor3);
        line-height: 1.38vw;
        padding-bottom: 0.694vw;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
      }
      .rowItem {
        position: relative;
        width: 20.83vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        line-height: 2.788vw;
        margin-bottom: 1.388vw;
        &:last-child {
          margin-bottom: 0;
        }
        .rowItem_bg {
          width: 100%;
          background-color: var(--mixtmt_greyColor7);
          height: 2.788vw;
          border-radius: 1.388vw;
        }
        .rowItem_title {
          display: block;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          width: 7.638vw;
          height: 100%;
          background: linear-gradient(
            90deg,
            var(--mixtmt_theme_defaultGradient_1_1) 0%,
            var(--mixtmt_theme_defaultGradient_1_2) 98%
          );
          color: var(--mixtmt_whiteColor);
          font-size: 1.11vw;
          font-weight: bold;
          text-align: center;
          border-radius: 1.388vw;
        }
        .rowItem_val {
          display: block;
          position: absolute;
          top: 0;
          right: 0;
          z-index: 2;
          width: calc(100% - 7.638vw);
          padding: 0 1.388vw;
          text-align: right;
          color: var(--mixtmt_greyColor3);
          font-size: 1.25vw;
          font-weight: bold;
        }
      }
    }
  }
  .bottom_tip {
    margin-top: 1.388vw;
    color: #999;
    font-size: 0.833vw;
  }
  .ptb4 {
    padding: 0.278vw 0;
  }
}
</style>
